import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import { getAiProjects } from '../../utils/workUtils';

const AIProjectsLanding = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    getAiProjects().then(setItems).catch(() => setItems([]));
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="pt-24 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl font-bold mb-6">AI-Projects</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {items.map((item) => (
              <Link key={item.id} to={item.link} className="group block">
                <div className="card bg-base-100 shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden rounded-none">
                  <figure className="relative">
                    <div className="w-full aspect-[16/9] overflow-hidden">
                      <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200" />
                    </div>
                  </figure>
                  <div className="px-0 py-0">
                    <h3 className="text-xl font-extrabold text-black line-clamp-2 mt-3">{item.title}</h3>
                    <div className="flex items-center gap-2 mt-2">
                      {item.badge && (
                        <span className="badge bg-orange-500 text-white border-none">{item.badge}</span>
                      )}
                    </div>
                    <p className="text-sm font-light leading-snug text-base-content/80 truncate mt-2 mb-3">{item.description}</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIProjectsLanding;

